import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import {CommonService} from '../../services/common.service';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { AuthService } from '../../authentication/auth.service';
@Component({
  selector: 'app-blogdetail',
  templateUrl: './blogdetail.component.html',
  styleUrls: ['./blogdetail.component.css']
})
export class BlogdetailComponent implements OnInit {
  uid: any;
  userimgarray = [];
  usernamearray = [];
  blogid: any;
  totalcomment: number;
  blog: any;
  comment: any;
  rblog: any;
  public loading = false;
  userStatus = 0;
  counter = 3;
  timer: any;
  user: any;
  message: any;
  upstatus = 0;
  constructor(private doctorService: DoctorService, private route: ActivatedRoute,
    private router: Router, private commonService: CommonService, private authService: AuthService) {
    this.route.params.subscribe(params => {
      this.blogid = params['id'];
      this.upstatus = 0;
      this.message = undefined;
      this.initialiseState();
      this.timer = setInterval(() => this.timedelay(), 1000)
    }
     );
   }

  ngOnInit() {
  }
  checkUserStatus() {
    this.userStatus = this.commonService.checkUserStatus();
  }
  getBlogDetail() {
    this.doctorService.getBogDetail(this.blogid)
    .subscribe(
      (x) => {
        this.blog = x;
        this.getrelatedBlog(this.blog[0].category);
      //  this.getCommentsOnBlog();
      });
  }
  getCommentsOnBlog() {
    this.doctorService.getCommentsOnBlog(this.blogid)
    .subscribe(
      (x) => {
        this.comment = x;
        this.totalcomment = this.comment.length;
        if(this.totalcomment == 0) {
          this.loading = false;
        }
     /*   for (let i = 0 ; i < this.comment.length ; i++) {
          this.getCommentUserDetail(this.comment[i].user_id)
        }*/
      });
  }
  getCommentUserDetail(uid) {
    this.doctorService.getCommentedUserDetail(uid)
    .subscribe(
    (x) => {
      this.totalcomment = this.totalcomment - 1;
      this.usernamearray['id' + uid] = x[0].name;
      this.userimgarray['id' + uid] = x[0].image;
      if(this.totalcomment == 0) {
        this.loading = false;
      }
    });
  }
  uploadComments() {
    this.loading = true;
      this.doctorService.uploadComments(this.blogid , this.uid , this.message)
      .subscribe(
        (x) => {
          this.upstatus = 1;
          this.getCommentsOnBlog();
        });
    }

    initialiseState() {
      this.getBlogDetail();
    }
    getrelatedBlog(cat) {
      this.doctorService.getCategoryBlogs(cat)
      .subscribe(
        (x) => {
          this.rblog = x;
        });
    }
    changeBlog(id, url) {
      this.router.navigate(['/blogs/detail/' + id, url])
    }
    login() {
      const flag = 10;
      this.commonService.setActivatepath(flag);
      this.router.navigate(['/signin']);
    }
    timedelay() {
      this.counter = this.counter  - 1;
      if (this.counter === 0) {
        const udata = this.commonService.getUserDataLocally();
        this.uid = udata.uid;
        this.checkUserStatus();
        clearInterval(this.timer);
       // this.getUserDetail()
      }
    }
    
    getUserDetail() {
      this.loading = true;
      this.doctorService.getCommentedUserDetail(this.uid)
      .subscribe(
      (x) => {
        this.user = x;
        this.loading = false;
      });
    }
  }
